import React from "react";
import { PROC_STATUS } from "./procHelpers";
import { procWho } from "./procPeople";

// Icônes et petits composants du manuel de procédures.
// Les tracés SVG sont ceux du prototype (ui.jsx et procedures-lib.jsx),
// repris à l'identique pour garder exactement le même rendu.

const SVG_PROPS = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const ICON_PATHS = {
  plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>,
  x: <><path d="M18 6L6 18" /><path d="M6 6l12 12" /></>,
  chev: <><path d="M9 6l6 6-6 6" /></>,
  alert: <><circle cx="12" cy="12" r="10" /><path d="M12 8v4" /><path d="M12 16h.01" /></>,
  pencil: <><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></>,
  dots: <><circle cx="5" cy="12" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="19" cy="12" r="1.5" /></>,
  check: <><path d="M5 12l5 5L20 7" /></>,
  info: <><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></>,
  folder: <><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" /></>,
  chevDown: <><path d="M6 9l6 6 6-6" /></>,
  download: <><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" /></>,
  shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></>,
  shieldCheck: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" /></>,
};

export const Icon = ({ name, size = 18, style, className }) => (
  <svg width={size} height={size} {...SVG_PROPS} style={style} className={className}>
    {ICON_PATHS[name]}
  </svg>
);

const PRICO_PATHS = {
  ul: <><path d="M9 6h11M9 12h11M9 18h11" /><circle cx="4.5" cy="6" r="1" /><circle cx="4.5" cy="12" r="1" /><circle cx="4.5" cy="18" r="1" /></>,
  ol: <><path d="M10 6h10M10 12h10M10 18h10" /><path d="M4 5l1-1v4M3.5 14h2l-2 2.5h2" /></>,
  chk: <><rect x="3" y="4" width="6" height="6" rx="1" /><path d="M4.5 7l1 1 2-2" /><rect x="3" y="14" width="6" height="6" rx="1" /><path d="M12 7h9M12 17h9" /></>,
  info: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M12 11v5M12 8h.01" /></>,
  warn: <><path d="M12 3l9.5 17h-19z" /><path d="M12 10v4M12 17h.01" /></>,
  tbl: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 10h18M3 15h18M12 4v16" /></>,
  link: <><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" /><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" /></>,
  hr: <><path d="M3 12h18" /></>,
  undo: <><path d="M9 14L4 9l5-5" /><path d="M4 9h11a5 5 0 0 1 0 10h-3" /></>,
  redo: <><path d="M15 14l5-5-5-5" /><path d="M20 9H9a5 5 0 0 0 0 10h3" /></>,
  clr: <><path d="M4 7V5h13v2M10 5l-3 14M5 19h6" /><path d="M15 14l5 5M20 14l-5 5" /></>,
  history: <><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /><path d="M12 7v5l3 2" /></>,
  star: <><path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z" /></>,
  book: <><path d="M4 4.5A1.5 1.5 0 0 1 5.5 3H20v15H5.5A1.5 1.5 0 0 0 4 19.5z" /><path d="M4 19.5A1.5 1.5 0 0 0 5.5 21H20v-3" /></>,
  home: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></>,
  activity: <><path d="M3 12h4l3-8 4 16 3-8h4" /></>,
  trash: <><path d="M4 7h16M10 11v6M14 11v6" /><path d="M6 7l1 13h10l1-13M9 7V4h6v3" /></>,
  copy: <><rect x="8" y="8" width="13" height="13" rx="2" /><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" /></>,
  restore: <><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /></>,
  calc: <><rect x="5" y="2.5" width="14" height="19" rx="2" /><rect x="8" y="5.5" width="8" height="3.5" rx=".6" /><path d="M8.5 12.5h.01M12 12.5h.01M15.5 12.5h.01M8.5 15.5h.01M12 15.5h.01M15.5 15.5v3M8.5 18.5h.01M12 18.5h.01" /></>,
  people: <><circle cx="9" cy="8" r="3.2" /><path d="M3 20a6 6 0 0 1 12 0" /><circle cx="17" cy="9" r="2.5" /><path d="M16 14.2a5 5 0 0 1 5.5 5.3" /></>,
  scale: <><path d="M12 3v18M7 21h10M5 7h14M12 5V3" /><path d="M5 7l-3 6a3 3 0 0 0 6 0z" /><path d="M19 7l-3 6a3 3 0 0 0 6 0z" /></>,
  office: <><rect x="4" y="3" width="16" height="18" rx="1.5" /><path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2" /><path d="M10 21v-3h4v3" /></>,
  monitor: <><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></>,
  xref: <><path d="M4 4.5A1.5 1.5 0 0 1 5.5 3H14v11H5.5A1.5 1.5 0 0 0 4 15.5z" /><path d="M4 15.5A1.5 1.5 0 0 0 5.5 17H9" /><path d="M14 17.5a2.5 2.5 0 0 1 2.5-2.5h1a2.5 2.5 0 0 1 0 5h-1M20 13" /><path d="M13 19.5h1.5" /></>,
  lock: <><rect x="4.5" y="10.5" width="15" height="10" rx="2" /><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" /></>,
  spark: <><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" /><path d="M19 15l.7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7z" /></>,
  send: <><path d="M4 12l16-8-6 16-2.5-6.5z" /><path d="M11.5 13.5L20 4" /></>,
  share: <><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" /></>,
  upload: <><path d="M12 16V4" /><path d="M7 9l5-5 5 5" /><path d="M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" /></>,
  doc: <><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6" /><path d="M8 13h8M8 17h5" /></>,
};

export const PrIco = ({ n, s = 16 }) => (
  <svg width={s} height={s} {...SVG_PROPS}>
    {PRICO_PATHS[n]}
  </svg>
);

export const ProcAv = ({ id, size = 24 }) => {
  const c = procWho(id);
  const hue = [...(c.id || "x")].reduce((a, ch) => a + ch.charCodeAt(0), 0) % 360;
  return (
    <span
      className="pr-av"
      title={c.name}
      style={{ width: size, height: size, fontSize: size * 0.4, background: `oklch(0.93 0.035 ${hue})`, color: `oklch(0.38 0.08 ${hue})` }}
    >
      {c.initials}
    </span>
  );
};

export const ProcStatus = ({ s }) => (
  <span className={`pr-status tone-${PROC_STATUS[s].tone}`}>{PROC_STATUS[s].lab}</span>
);
